import { useState } from 'react';
import { Icon, TIconName } from '@pu/mpp-ui/components/icon';

import './platform-selector.scss';

export interface IPlatformItem {
  id: number;
  label: string;
  icon?: TIconName;
  active?: boolean;
  disabled?: boolean;
}

export interface IPlatformProps {
  items: Array<IPlatformItem>;
  selectedItem: number;
  onItemSelect: (id: number) => void;
}

const PlatformSelector = ({ items = [], selectedItem: selectedItemId, onItemSelect }: IPlatformProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (id: number) => {
    onItemSelect(id);
    setIsOpen(false);
  };

  const selectedItem = items.find(item => item.id === selectedItemId) || items[0];
  const itemsToShow = items.filter(item => item.id !== selectedItemId);

  return (
    <div className="platform-selector">
      <button className="platform-selector__toggle" onClick={toggleDropdown} type="button" aria-expanded={isOpen}>
        <div className="platform-selector__selected">
          <Icon name={selectedItem?.icon || 'globe'} size="md" weight="bold" />
          {selectedItem?.label || 'Select an option'}
        </div>
        <div className={`platform-selector__arrow ${isOpen ? 'platform-selector__arrow--open' : ''}`}>
          <Icon name="caret-up" size="sm" weight="bold" />
          <Icon name="caret-down" size="sm" weight="bold" />
        </div>
      </button>

      {isOpen && (
        <div className="platform-selector__menu">
          {itemsToShow.map(item => (
            <button
              key={item.id}
              className={`platform-selector__item 
                ${item.active ? 'platform-selector__item--active' : ''} 
                ${item.disabled ? 'platform-selector__item--disabled' : ''}`}
              onClick={() => !item.disabled && handleItemClick(item.id)}
              type="button"
            >
              <Icon className="platform-selector__item-icon" name={item.icon || 'globe'} size="md" weight="bold" />
              <span className="platform-selector__label">{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlatformSelector;
